import { Injectable, inject } from '@angular/core';
import { DfEventData, DfEventService } from '@df/core/service/df-event';
import { GtmDataService } from '@df/module-gtm/service/gtm-data.service';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import './gtm-event-basket-update';

@Injectable({
    providedIn: 'root'
})
export class GtmEventBasketUpdateTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * GTM basket service
     */
    private gtmDataService = inject(GtmDataService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup event listener
     */
    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'basketDataChange') {
                this.dispatch(event);
            }
        });
    }

    /**
     * Dispatch event
     */
    private async dispatch(trigger: DfEventData) {
        return this.gtmService.dispatch({
            event: 'basket_update',
            triggerContext: {
                trigger
            },
            basket: await this.gtmDataService.getEventData(this.gtmDataService.getBasketItems(), this.gtmDataService.getBasketExtras())
        });
    }
}
